import { useState, useEffect } from "react";
import { Radio, Play, ArrowSquareOut } from "@phosphor-icons/react";
import { fetchRadioStreams } from "../lib/api";

export default function RadioPlayer() {
  const [streams, setStreams] = useState([]);

  useEffect(() => {
    fetchRadioStreams().then((data) => setStreams(data.streams || []));
  }, []);

  if (!streams.length) return null;

  return (
    <section data-testid="radio-player" className="mb-8 border border-zinc-800">
      <div className="bg-[#111] text-white px-4 py-3 flex items-center gap-2">
        <Radio weight="bold" size={16} className="text-[#D4AF37]" />
        <span className="mono-label text-[#D4AF37]">Live Racing Radio</span>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 divide-y sm:divide-y-0 sm:divide-x divide-zinc-800">
        {streams.map((s, i) => (
          <a
            key={i}
            href={s.url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`radio-stream-${i}`}
            className="flex items-center gap-3 p-3 hover:bg-zinc-800/50 transition-colors group"
          >
            <div className="w-9 h-9 bg-[#D4AF37] flex items-center justify-center flex-shrink-0 group-hover:bg-[#C4A030] transition-colors">
              <Play weight="fill" size={16} className="text-black ml-0.5" />
            </div>
            <div className="flex-1">
              <p className="text-sm font-semibold text-white group-hover:text-[#D4AF37] transition-colors">{s.name}</p>
              <p className="text-[10px] text-zinc-500">{s.description}</p>
            </div>
            <div className="flex items-center gap-1.5">
              {s.free && <span className="bg-[#008A27] text-white px-1.5 py-0.5 text-[8px] font-mono font-bold uppercase">Free</span>}
              <ArrowSquareOut weight="bold" size={14} className="text-zinc-600" />
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}
